/**
 * ErrorBoundary — Shows exact crash reason on screen in ALL environments
 */

import React from "react";
import { Button } from "antd";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, componentStack: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("=== ErrorBoundary caught crash ===");
    console.error("Error:", error?.message);
    console.error("Stack:", error?.stack);
    console.error("Component Stack:", info?.componentStack);

    this.setState({ componentStack: info?.componentStack });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: 20,
          fontFamily: "monospace",
          backgroundColor: "#fff1f0",
          minHeight: "100vh",
        }}>
          {/* Error Title */}
          <div style={{
            backgroundColor: "#ff4d4f",
            color: "#fff",
            padding: "10px 16px",
            borderRadius: 8,
            fontWeight: 700,
            fontSize: 14,
            marginBottom: 12,
          }}>
            ❌ App Crashed — Share this screen with developer
          </div>

          {/* Error Message */}
          <div style={{
            backgroundColor: "#fff",
            border: "1px solid #ffccc7",
            borderRadius: 8,
            padding: 12,
            marginBottom: 12,
          }}>
            <div style={{ fontSize: 11, color: "#999", marginBottom: 4 }}>ERROR MESSAGE</div>
            <div style={{ fontSize: 13, color: "#cf1322", fontWeight: 600, wordBreak: "break-all" }}>
              {this.state.error?.message || "Unknown error"}
            </div>
          </div>

          {/* Component Stack */}
          {this.state.componentStack && (
            <div style={{
              backgroundColor: "#fff",
              border: "1px solid #ffccc7",
              borderRadius: 8,
              padding: 12,
              marginBottom: 16,
            }}>
              <div style={{ fontSize: 11, color: "#999", marginBottom: 4 }}>COMPONENT STACK</div>
              <pre style={{
                fontSize: 11,
                color: "#555",
                margin: 0,
                whiteSpace: "pre-wrap",
                wordBreak: "break-all",
                maxHeight: 300,
                overflowY: "auto",
              }}>
                {this.state.componentStack}
              </pre>
            </div>
          )}

          {/* Refresh Button */}
          <button
            onClick={() => window.location.reload()}
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: "#ff4d4f",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;